import React from 'react';

interface HighlightedTextProps {
  text: string;
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({ text }) => {
  // Pattern to match text between ** ** (bold markdown)
  const parts = text.split(/(\*\*.*?\*\*)/g);

  return (
    <>
      {parts.map((part, index) => {
        // Check if this part is between ** **
        if (part.startsWith('**') && part.endsWith('**')) {
          const content = part.slice(2, -2);
          return (
            <strong key={index} className="highlight">
              {content}
            </strong>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </>
  );
};
